
import { withPending, withRejected, withFulFilled } from './commons';
import {
  STORE_MULTI_CROSS_CONFIG,
  FETCH_MULTI_CROSS_CONFIG,
  REMOVE_MULTI_CROSS_CONFIG,
  UPDATE_MULTI_CROSS_CONFIG,
  FIND_MULTI_CROSS_CONFIG,
  STORE_CORRELATION_CONFIG,
  FETCH_CORRELATION_CONFIG,
  REMOVE_CORRELATION_CONFIG,
  UPDATE_CORRELATION_CONFIG,
  FIND_CORRELATION_CONFIG,
  STORE_AUTO_CORRELATION_CONFIG,
  FETCH_AUTO_CORRELATION_CONFIG,
  FIND_EVOLUTIVO_CONFIG,
  FETCH_SIMULATION_CONFIG,
} from '../actions/configs';

// initial state
const INITIAL_STATE = {
  multiCrossConfig: {
    running: false,
    error: null,
    payload: null, // {id: number, descricao: string}
  },
  multiCrossConfigs: {
    running: false,
    error: null,
    payload: null, // [{id_configuracao: number, resultados: array}]
  },
  correlationConfig: {
    running: false,
    error: null,
    payload: null, // {id: number, descricao: string}
  },
  correlationConfigs: {
    running: false,
    error: null,
    payload: null, // {id_configuracao: number, resultados: array}
  },
  autoCorrelationConfig: {
    running: false,
    error: null,
    payload: null, // {minMaxCorrValue}
  },
  evolutiveConfig: {
    running: false,
    error: null,
    payload: null, // {object}
  },
  evolutiveCrossConfig: {
    running: false,
    error: null,
    payload: null,
  },
  simulationConfigs: {
    running: false,
    error: null,
    payload: null, // {id_configuracao: number, resultados: array}
  },
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  // store multcross config
  case withPending(STORE_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfig: { running: true }};
  case withRejected(STORE_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfig: { running: false, error: action.payload }};
  case withFulFilled(STORE_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfig: { running: false, payload: action.payload.data }};
    // update multcross config
  case withPending(UPDATE_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfig: { running: true }};
  case withRejected(UPDATE_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfig: { running: false, error: action.payload }};
  case withFulFilled(UPDATE_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfig: { running: false, payload: action.payload.data }};
    // find multcross config
  case withPending(FIND_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfig: { running: true }};
  case withRejected(FIND_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfig: { running: false, error: action.payload }};
  case withFulFilled(FIND_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfig: { running: false, payload: action.payload.data }};
    // remove multcross config
  case withPending(REMOVE_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfigs: { running: true }};
  case withRejected(REMOVE_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfigs: { running: false, error: action.payload }};
  case withFulFilled(REMOVE_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfigs: { running: false, payload: action.payload.data }};
    // list multcross config
  case withPending(FETCH_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfigs: { running: true }};
  case withRejected(FETCH_MULTI_CROSS_CONFIG):
    return { ...state, multiCrossConfigs: { running: false, error: action.payload }};
  case withFulFilled(FETCH_MULTI_CROSS_CONFIG): {
    return { ...state, multiCrossConfigs: { running: false, payload: action.payload.data }};
  }
  // store correlation config
  case withPending(STORE_CORRELATION_CONFIG):
    return { ...state, correlationConfig: { running: true }};
  case withRejected(STORE_CORRELATION_CONFIG):
    return { ...state, correlationConfig: { running: false, error: action.payload }};
  case withFulFilled(STORE_CORRELATION_CONFIG):
    return { ...state, correlationConfig: { running: false, payload: action.payload.data }};
    // update correlation config
  case withPending(UPDATE_CORRELATION_CONFIG):
    return { ...state, correlationConfig: { running: true }};
  case withRejected(UPDATE_CORRELATION_CONFIG):
    return { ...state, correlationConfig: { running: false, error: action.payload }};
  case withFulFilled(UPDATE_CORRELATION_CONFIG):
    return { ...state, correlationConfig: { running: false, payload: action.payload.data }};
    // find correlation config
  case withPending(FIND_CORRELATION_CONFIG):
    return { ...state, correlationConfig: { running: true }};
  case withRejected(FIND_CORRELATION_CONFIG):
    return { ...state, correlationConfig: { running: false, error: action.payload }};
  case withFulFilled(FIND_CORRELATION_CONFIG):
    return { ...state, correlationConfig: { running: false, payload: action.payload.data }};
    // remove correlation config
  case withPending(REMOVE_CORRELATION_CONFIG):
    return { ...state, correlationConfigs: { running: true }};
  case withRejected(REMOVE_CORRELATION_CONFIG):
    return { ...state, correlationConfigs: { running: false, error: action.payload }};
  case withFulFilled(REMOVE_CORRELATION_CONFIG):
    return { ...state, correlationConfigs: { running: false, payload: action.payload.data }};
    // list correlation config
  case withPending(FETCH_CORRELATION_CONFIG):
    return { ...state, correlationConfigs: { running: true }};
  case withRejected(FETCH_CORRELATION_CONFIG):
    return { ...state, correlationConfigs: { running: false, error: action.payload }};
  case withFulFilled(FETCH_CORRELATION_CONFIG):
    return { ...state, correlationConfigs: { running: false, payload: action.payload.data }};
    // store auto correlation config
  case withPending(STORE_AUTO_CORRELATION_CONFIG):
    return { ...state, autoCorrelationConfig: { running: true }};
  case withRejected(STORE_AUTO_CORRELATION_CONFIG):
    return { ...state, autoCorrelationConfig: { running: false, error: action.payload }};
  case withFulFilled(STORE_AUTO_CORRELATION_CONFIG):
    return { ...state, autoCorrelationConfig: { running: false, payload: action.payload.data }};
    // fetch auto correlation config
  case withPending(FETCH_AUTO_CORRELATION_CONFIG):
    return { ...state, autoCorrelationConfig: { running: true }};
  case withRejected(FETCH_AUTO_CORRELATION_CONFIG):
    return { ...state, autoCorrelationConfig: { running: false, error: action.payload }};
  case withFulFilled(FETCH_AUTO_CORRELATION_CONFIG):
    return { ...state, autoCorrelationConfig: { running: false, payload: action.payload.data }};
    // find evolutive config
  case withPending(FIND_EVOLUTIVO_CONFIG):
    return { ...state, evolutiveConfig: { running: true }};
  case withRejected(FIND_EVOLUTIVO_CONFIG):
    return { ...state, evolutiveConfig: { running: false, error: action.payload }};
  case withFulFilled(FIND_EVOLUTIVO_CONFIG):
    return { ...state, evolutiveConfig: { running: false, payload: action.payload.data }};
    // fetch simulation config
  case withPending(FETCH_SIMULATION_CONFIG):
    return { ...state, simulationConfigs: { running: true, error: null, payload: null }};
  case withRejected(FETCH_SIMULATION_CONFIG):
    return { ...state, simulationConfigs: { running: false, error: action.payload, payload: null }};
  case withFulFilled(FETCH_SIMULATION_CONFIG):
    return { ...state, simulationConfigs: { running: false, error: null, payload: action.payload.data }};
    // nothing
  default:
    return state;
  }
};

export default execute;
